module.exports = __webpack_public_path__ + "static/media/icon-report-more.8301baec.svg";